<template>
  <div class="container">
      <!-- 网吧名称 -->
    <div class="customerinfo-box">
      <div class="customerinfo-box-left">
        <div class="customerinfo-box-title">{{detailsInfo.siteName}}</div>
        <div class="customerinfo-box-address">{{detailsInfo.siteAddress}}</div>
      </div>
      <div class="customerinfo-box-right" @click="handleGopageClick">
        <img src="@/images/mapicon.png" alt srcset />
        <div class="customerinfo-box-text">地图</div>
      </div>
    </div>
    <!-- 网吧联系人 -->
    <div class="customerinfo-box2">
        <div>联系人：{{detailsInfo.principalName}}</div>
        <div>联系电话：{{detailsInfo.principalTel}}</div>
         <div>管辖地派出所：{{detailsInfo.policeName}}</div>
    </div>
    <!-- 添加备注 -->
      <div class="customerinfo-box3" v-show="detailsInfo.isRemark == 1" @click="handleAddNoteGoPage">
          添加备注
    </div>
     <div class="customerinfo-box3" v-show="detailsInfo.isRemark == 0">
          {{detailsInfo.remark}}
    </div>
    <!-- 按钮 -->
        <div class="btn">
      <span @click="handleClickGopageUser">人员管理</span>
      <span @click="handleClickGopageInfo">信息管理</span>
    </div>
  </div>
</template>

<script>
import { CustomerDetails } from '@/api/customer'
import { request } from 'http'
export default {
    data() {
      return {
          detailsInfo:''
      }
    },
    mounted() {
      this.requestCustomerDetails()
    },
    methods: {
        // 详情列表
        requestCustomerDetails() {
          let internetBarId = this.$route.query.internetBarId
          CustomerDetails({internetBarId:internetBarId}).then(res=>{
            console.log(res)
            this.detailsInfo = res.data
          })
        },
        // 跳转到添加备注列表
        handleAddNoteGoPage() {
            let internetBarId = this.$route.query.internetBarId
            this.$router.push({
              path:'/customernote',
              query:{
                internetBarId:internetBarId
              }
            })
        },
        // 跳转到用户网吧管理人员页面
        handleClickGopageUser() {
            let internetBarId = this.$route.query.internetBarId
            this.$router.push({
               path:'/customeruser',
               query:{
                 internetBarId:internetBarId
               }
            })
        },
        // 跳转到信息管理页面
        handleClickGopageInfo() {
            let internetBarId = this.$route.query.internetBarId
            this.$router.push({
                path:'/infomanagement',
                query:{
                  internetBarId:internetBarId
                }
            })
        },
        // 点击跳转地图页面
        handleGopageClick() {
          let  name = this.detailsInfo.siteName;
          let url = 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:'+this.detailsInfo.latitude+','+this.detailsInfo.longitude+';title:'+ name +';addr:'+this.detailsInfo.siteAddress+'&key=YEQBZ-KHBK5-UXEIE-QYYJ7-YEVP7-VKBRG&referer=myapp'
          window.location.href = url
        }
    }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow: hidden;
  .customerinfo-box {
    width: 100%;
    height: 85px;
    padding: 20px 10px;
    box-sizing: border-box;
    background-color: #ffffff;
    margin-top: 10px;
    text-align: left;
    .customerinfo-box-left {
      width: 296px;
      height: 50px;
      float: left;
      border-right: 2px solid #eeeeee;

      .customerinfo-box-title {
        width: 100%;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
      }
      .customerinfo-box-address {
        width: 100%;
        color: #999999;
        font-size: 14px;
        margin-top: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .customerinfo-box-right {
      float: right;
      margin-right: 10px;
      img {
        width: 22px;
        height: 20px;
        margin-left: 3px;
        margin-top: 4px;
      }
      .customerinfo-box-text {
        text-align: center;
        font-size: 13px;
        color: #008cff;
        margin-top: 2px;
      }
    }

  }
      //   网吧人员信息
    .customerinfo-box2 {
      width: 100%;
      height: 112px;
      padding: 20px 10px;
      box-sizing: border-box;
      background-color: #ffffff;
      margin-top: 10px;
      text-align: left;
      div {
          color: #333333;
          font-size: 15px;
          padding-bottom: 14px;
          box-sizing: border-box;
      }
    }
    // 添加备注
    .customerinfo-box3 {
      width: 100%;
      height: 55px;
      line-height: 55px;
      background-color: #ffffff;
      margin-top: 10px;
      text-align: left;
      font-size: 15px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    .btn {
    width: 350px;
    margin: 0 auto;
    span {
      display: inline-block;
      width: 150px;
      height: 44px;
      border: 1px solid #008cff;
      text-align: center;
      line-height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: bold;
      color: #008cff;
      margin: 0px 10px;
      margin-top: 106px;
      margin-bottom: 10px;
      &:hover {
        background: -webkit-linear-gradient(left, #05aefc, #008cff);
        color: #ffffff;
      }
    }
  }
}
</style>
